<a class="sr-only focusable" href="#main-content" (click)="skipToMain($event)">
  {{ "navigation.skip.maincontent" | translate }}
</a>

<div class="flex flex-col h-full">
  <app-topbar class="flex-shrink-0" [hasLanguage]="hasLanguage">
    <ng-content select="[appLanguage]" appLanguage></ng-content>
  </app-topbar>

  <div class="flex flex-col flex-1 min-h-0 background-image-dynamic-theme">
    <div
      class="survey-background-overlay flex-1 min-h-0 overflow-y-auto overflow-x-hidden layout-scroll"
    >
      <div
        class="md:grid md:grid-cols-12 lg:max-w-[1920px] lg:mx-auto lg:gap-4"
      >
        <div class="h-0 md:h-full md:col-span-2 ml-4 xl:col-start-2"></div>

        <div
          class="h-full pt-5 pb-4 md:col-start-4 md:col-span-6 content-center px-6 md:px-0"
        >
          <main id="main-content" tabindex="-1" class="w-full md:px-8">
            <ng-content select="[primary]"></ng-content>
            <div class="md:w-1/2 mt-8 mg:">
              <ng-content select="[secondary]"></ng-content>
            </div>
          </main>
        </div>
      </div>
    </div>
  </div>

  <div class="layout-nav">
    <ng-content select="[navigation]"></ng-content>
  </div>
</div>
